export * from './ContactsList.container'



// WEBPACK FOOTER //
// src/features/Contacts/ContactsList/index.ts